import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import get from 'lodash/get';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { withRouter } from 'react-router';
import Helmet from 'react-helmet';
import { withUrlGenerator } from '@folklore/react-app';

import Slideshow from '../blocks/Slideshow';
import SectionText from '../blocks/SectionText';
import LatestNews from '../partials/LatestNews';

import styles from '../../../styles/pages/home.scss';

const propTypes = {
    width: PropTypes.number.isRequired,
    height: PropTypes.number.isRequired,
    intl: PropTypes.shape({
        formatMessage: PropTypes.func,
    }).isRequired,
    urlGenerator: PropTypes.shape({
        route: PropTypes.func,
    }).isRequired,
    aboutPage: PropTypes.shape({
        url: PropTypes.string,
    }),
    newsPage: PropTypes.shape({
        url: PropTypes.string,
    }),
    page: PropTypes.shape({
        data: PropTypes.shape({
            slides: PropTypes.array,
            about: PropTypes.object,
        }),
    }).isRequired,
};

const defaultProps = {
    aboutPage: null,
};

class HomePage extends Component {
    constructor(props) {
        super(props);

        this.timeline = null;
    }

    componentDidMount() {}

    render() {
        const {
            intl, width, height, page, aboutPage, newsPage,
        } = this.props;
        const { formatMessage } = intl;

        const slides = get(page, 'data.slides', []);
        const about = get(page, 'data.about', []);
        const aboutLink = get(aboutPage, 'url', 'about');
        const newsLink = get(newsPage, 'url', 'news');

        // prettier-ignore
        const slideshowHeight = width > height
            ? (height - (height * 0.05))
            : (height - (height * 0.15));
        const slideshowStyle = {
            height: slideshowHeight,
        };

        return (
            <div className={styles.container}>
                <Helmet>
                    <title>
                        {formatMessage({
                            id: 'meta.title',
                            defaultMessage: 'Accueil',
                        })}
                    </title>
                </Helmet>
                <div
                    className={classNames({
                        [styles.section]: true,
                        [styles.slideshow]: true,
                    })}
                    style={slideshowStyle}
                >
                    <Slideshow
                        width={width}
                        height={slideshowHeight}
                        slides={slides}
                        looping
                        onSlideChange={this.onSlideChange}
                    />
                </div>
                <div
                    className={classNames({
                        [styles.section]: true,
                        [styles.description]: true,
                    })}
                >
                    <SectionText {...about} moreInfoLink={aboutLink} centered />
                </div>
                <div
                    className={classNames({
                        [styles.section]: true,
                        [styles.news]: true,
                    })}
                >
                    <LatestNews moreInfoLink={newsLink} />
                </div>
            </div>
        );
    }
}

HomePage.propTypes = propTypes;
HomePage.defaultProps = defaultProps;

const mapStateToProps = ({ site, layout }, { location }) => ({
    ...layout.size,
    aboutPage: site.pages.find(it => it.handle === 'about') || null,
    newsPage: site.pages.find(it => it.handle === 'news') || null,
    page:
        site.page !== null && site.page.url === location.pathname
            ? site.page
            : site.pages.find(it => it.url === location.pathname) || null,
});
const WithStateContainer = connect(mapStateToProps)(HomePage);
const WithIntlContainer = injectIntl(WithStateContainer);
const WithUrlGeneratorContainer = withUrlGenerator()(WithIntlContainer);
const WithRouterContainer = withRouter(WithUrlGeneratorContainer);

export default WithRouterContainer;



// WEBPACK FOOTER //
// ./js/components/pages/Home.jsx